module.exports = __webpack_public_path__ + "static/media/celebrity.a5e1d633.jpg";